import { Button, Grid } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useAppContext } from "AppContext";
import CommonPagination from "components/CommonPagination";
import GKTable from "components/GKTable";
import dayjs from "dayjs";
import { useState } from "react";
import { useParams } from "react-router-dom";
import axiosInstance from "utils/axiosInstance";
import HistoricalModal from "./HistoricalModal";

const HistoricalPrices = () => {
  const { id } = useParams();

  const [isOpenModal, setIsOpenModal] = useState(false);

  const [type, setType] = useState("");

  const {
    state: { currentUser },
  } = useAppContext();

  const isDisabled = currentUser?.phone === "9911223344";

  const {
    state: { commonFilter },
  } = useAppContext();

  const requestBody = {
    take: commonFilter?.historicalList?.take,
    skip: commonFilter?.historicalList?.skip,
    sort: JSON.stringify(
      commonFilter?.historicalList?.sortModel?.map((data) => {
        return {
          selector: data.field,
          desc: data.sort !== "asc",
        };
      })
    ),
    search: commonFilter?.historicalList?.search || "",
  };

  const { data, isFetching, refetch } = useQuery({
    queryKey: ["ADMIN_INSTRUMENT_HMP", requestBody],
    queryFn: async () =>
      axiosInstance.get(`/admin-instrument-hmp/${id}/`, {
        params: requestBody,
      }),
  });

  const cusPagination = () => {
    return (
      <CommonPagination
        name="historicalList"
        totalCount={data?.data?.totalCount || 0}
      />
    );
  };

  const historicalPriceColumns = [
    {
      headerName: "Timestamp",
      field: "timestamp",
      flex: 1,
      disableColumnMenu: true,
      sortable: false,
      valueGetter: (row) => dayjs(row?.row?.timestamp).format("DD/MM/YYYY"),
    },
    {
      headerName: "Adjusted Price",
      field: "adjustedPrice",
      type: "number",
      flex: 1,
      disableColumnMenu: true,
      sortable: false,
      valueGetter: (row) => parseFloat(row?.row?.adjustedPrice).toFixed(2),
    },
    {
      headerName: "Unadjusted Price",
      field: "unadjustedPrice",
      type: "number",
      flex: 1,
      disableColumnMenu: true,
      sortable: false,
      valueGetter: (row) => parseFloat(row?.row?.unadjustedPrice).toFixed(2),
    },
  ];
  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <GKTable
          loading={isFetching}
          columns={historicalPriceColumns}
          rows={data?.data?.data || []}
          maxHeight={"calc(100vh - 0px)"}
          searchPlaceholder="Search for historical"
          CustomPagination={!isFetching && cusPagination}
          filterButton={false}
          headerComponent={
            <Grid item>
              <Button
                sx={{
                  fontSize: "0.7rem",
                  fontFamily: '"Arial", sans-serif',
                  textTransform: "none",
                }}
                onClick={() => {
                  setType("HMP");
                  setIsOpenModal(true);
                }}
                variant="outlined"
                disabled={isDisabled}
              >
                Add HMP
              </Button>
              &nbsp;
              <Button
                sx={{
                  fontSize: "0.7rem",
                  fontFamily: '"Arial", sans-serif',
                  textTransform: "none",
                }}
                variant="outlined"
                onClick={() => {
                  setType("CMP");
                  setIsOpenModal(true);
                }}
                disabled={isDisabled}
              >
                Update CMP
              </Button>
            </Grid>
          }
          name="historicalList"
        />
      </Grid>
      {isOpenModal && (
        <HistoricalModal
          open={isOpenModal}
          setOpen={setIsOpenModal}
          type={type}
          refetch={refetch}
        />
      )}
    </Grid>
  );
};

export default HistoricalPrices;
